const formatNumber = number => {
  if (!Intl) return number;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })
    .format(number)
    .replace(/\D00$/, '')
    .replace('$ ', '$');
};

export function removeTrailingZeros(moneyAmount) {
  const lastIndexZeros = moneyAmount.lastIndexOf('.00');
  if (lastIndexZeros < moneyAmount.length - 3) return moneyAmount;
  return moneyAmount.slice(0, lastIndexZeros);
}

export function formatMoney(country, amount) {
  const result = new Intl.NumberFormat(country.lang, {
    style: 'currency',
    currency: country.currency
  }).format(Number(amount));
  return removeTrailingZeros(result);
}

export default formatNumber;
